<div class='admissions-accelerators-tab-2-part'>
	This is admissions-accelerators tab 2
</div>